import TransferView from '@/views/TransferView.vue'
import { hasFeatureFlagActive } from '@/engine/featureFlags/featureFlags.state'
import { FEATURE_FLAGS } from '@/engine/featureFlags/flags'
import type { RouteRecordRaw } from 'vue-router'
import ROUTES from './routes'

export default [
  {
    path: '/transfer',
    name: ROUTES.TRANSFER,
    component: TransferView,
    beforeEnter: () => {
      if (!hasFeatureFlagActive(FEATURE_FLAGS.CHARGER_TRANSFER_ACCEPTANCE)) {
        return { name: ROUTES.NOT_FOUND }
      }
    }
  }
] as RouteRecordRaw[]
